<template>
  <div class="customization-wizard-header">
    <h5>
      <span>Color & Customization Settings</span>

      <div class="wizard-actions">
        <button class="btn btn-back" v-if="customizationStep !== 'home'" title="Back" @click="goToStep()">
          <img src="@/assets/icons/ui/arrow-back-outline.svg">
        </button>
        <button class="btn close-modal" title="Close" @click="closeModal()">
          <img src="@/assets/icons/ui/close-outline.png" alt="close">
        </button>
      </div>

    </h5>

  
    <!-- Help information that can be dismissable -->
    <template>
      <div class="customization-box-help" v-if="!customizationsHelpRead">
        <p>This is where you can make changes to your Showroom, such as adjusting colors or the decorations of all of your items.</p>
        <p>We got you started with some Uniform and Spiritwear decorations, but if you want to change those just click on them to make adjustments!</p>
        <p><b>You can still customize items individually if you prefer</b>, but if you want to make global changes to your Showroom this will save you time!</p>
        <div class="customization-box-help-actions">
          <button class="customization-box-help-action" @click="readCustomizationsHelp">
            Great, makes sense!
          </button>
        </div>
      </div>
    </template>    

  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
  name: 'CustomizationBoxMain',

  computed: {

    ...mapState("showroom", ["customizationsHelpRead", "customizationStep"]),

  },

  methods: {

    ...mapActions("showroom", ["readCustomizationsHelp", "setCustomizationStep", "toggleCustomizationBox"]),
    
    goToStep() {
      this.setCustomizationStep(this.backToStep)
    },

    closeModal() {
      this.setCustomizationStep('home')
      this.toggleCustomizationBox()
    }

  },

  mounted() {
    this.setCustomizationStep('home')
  },

  props: {
    backToStep: {
      type: String
    }
  }

}
</script>

<style lang="scss" scoped>
  #app {
    
    .customization-wizard-header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;

      h5 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex: 1;
        .wizard-actions {
          display: flex;
        }
      }

      .wizard-title {
        display: flex;
      }

      .btn-back{
        margin-right: 1rem;
      }
      .btn-back, .close-modal {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        background: #F9FAFA;
        padding: 1px 2px;
        border-radius: 6px;
        color: #666;
        transition: filter .2s;

        &:hover{
          filter: invert(1);
        }
      }

      .customization-box-help {
        display: flex;
        flex-direction: column;
        padding: 25px;
        border-bottom: 1px solid #ECEDED;

        p {
          font-size: 18px;
          line-height: 130%;
          color: #6D7283;
          margin: 15px 0;
        }

        .customization-box-help-actions {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          margin: 15px 0px;

          .customization-box-help-action {
            padding: 8px 16px;
            background: #FFFFFF;
            border: 1px solid #D8DADF;
            box-sizing: border-box;
            border-radius: 56px;
            cursor: pointer;
            &:hover{
              text-decoration: underline;
            }
          }
        }
      }

      .team-colors {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 25px;
      }

      .team-decorations {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px 25px;
      }
    }
  }
</style>